import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4 7a2 2 0 100-4 2 2 0 000 4zm16.2 8.4L18.5 18l-6.8 1-1.7-4.3c-.1-.3-.4-.5-.7-.6l-3.4-.9-.6-2.2H11c.6 0 1-.4 1-1s-.4-1-1-1H4c-.3 0-.6.1-.8.4-.2.2-.2.5-.2.8l1 4c.1.4.4.6.7.7l3.5.9 1.4 3.4-5.7.8c-.5.1-.9.6-.9 1.1.1.5.5.9 1 .9h.1l15-2c.3 0 .5-.2.7-.4l2-3c.3-.5.2-1.1-.3-1.4-.4-.3-1-.2-1.3.2zM16 12c0 .6-.4 1-1 1s-1-.4-1-1V8c0-.6.4-1 1-1s1 .4 1 1v1h5c.6 0 1 .4 1 1s-.4 1-1 1h-5v1z"
  />,
  'WaterSkiing'
)
